"use client";

import { useState } from "react";

export const EXPANDED_KEY = "caw:sidebar-folders";

export interface FolderExpansion {
  isExpanded: (id: string) => boolean;
  toggle: (id: string) => void;
  /** Opens a folder for this visit only, so a new child's input is in view. */
  expand: (id: string) => void;
}

/** Which departments are collapsed, remembered in localStorage across visits. */
export function useFolderExpansion(): FolderExpansion {
  const [expanded, setExpanded] = useState<Record<string, boolean>>(() => {
    if (typeof window === "undefined") return {};
    try {
      return JSON.parse(localStorage.getItem(EXPANDED_KEY) ?? "{}");
    } catch {
      return {};
    }
  });

  function isExpanded(id: string) {
    return expanded[id] ?? true;
  }

  function toggle(id: string) {
    setExpanded((cur) => {
      const next = { ...cur, [id]: !(cur[id] ?? true) };
      try {
        localStorage.setItem(EXPANDED_KEY, JSON.stringify(next));
      } catch {
        // persistence is best-effort
      }
      return next;
    });
  }

  function expand(id: string) {
    setExpanded((cur) => ({ ...cur, [id]: true }));
  }

  return { isExpanded, toggle, expand };
}
